module.exports = __webpack_public_path__ + "static/img/icon_pro4.9ccfde0.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_pro4.png
// module id = WLLK
// module chunks = 11